'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = requireFields;

var _get = require('lodash-es/get');

var _get2 = _interopRequireDefault(_get);

var _set = require('lodash-es/set');

var _set2 = _interopRequireDefault(_set);

var _i18n = require('../i18n/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Validační funkce generovaná funkcí requireFields.
 *
 * @callback requireFieldsValidator
 * @param {Object} values - formulářové hodnoty pro zvalidování
 * @param {Object} [errors={}] - objekt pro zápis chyb polí
 * @return {Object} objekt se zapsanými chybami polí
 */

/**
 * Vytvoří validační funkci povinných polí formuláře.
 * Výslednou funkci lze použít v rámci validace přes redux-form.
 *
 * Použití:
 * ```
 * // Konstrukce validároru
 * const validator = requireFields(['jmeno', 'adresa.ulice']);
 *
 * // 1. Způsob použití
 * const errors = validator(formValues);
 *
 * // 2. Způsob použití
 * const errors = {};
 * validator(formValues, errors);
 * ```
 *
 * Použití (konfigurační volby):
 * ```
 * const validator = requireFields(['jmeno', 'adresa.ulice'], {
 *      errorMessage: 'Moje vlastní chybová zpráva',
 *      trimStrings: true, // Řetězce obsahující pouze mezery budou reportovány jako chyby
 * });
 * ```
 *
 * @param {string[]} paths - seznam názvů polí, které chceme validovat. Lze uvéset i otečkované cesty
 *                           pro specifikaci polí v zanořených datových strukturách, např. 'subjekt.adresa.ulice'
 *                           zvaliduje vyplněnost pole ve struktuře `{subjekt: {adresa: {ulice: ???}}}`
 * @param {Object} [options] - volitelné parametry
 * @param {string} [options.errorMessage] - volitelná chybová zpráva, použitá pro nevyplněná povinná pole
 * @param {boolean} [options.trimStrings=false] - příznak, zda string hodnoty trimovat, tzn. zda je
 *                                                string obsahující poze mezery považován za validační chybu
 * @returns {requireFieldsValidator} výsledná validační funkce
 */
function requireFields(paths) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (typeof options === 'string') {
        options = { errorMessage: options }; // Zpětná kompatibilita, druhý parametr dříve představoval errorMessage
    }

    var _options = options,
        _options$errorMessage = _options.errorMessage,
        errorMessage = _options$errorMessage === undefined ? (0, _i18n2.default)('global.form.title.error.required') : _options$errorMessage,
        _options$trimStrings = _options.trimStrings,
        trimStrings = _options$trimStrings === undefined ? false : _options$trimStrings;


    return function (values) {
        var errors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(paths), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var path = _step.value;

                var value = (0, _get2.default)(values, path);

                if (trimStrings && typeof value === 'string') {
                    value = value.trim();
                }

                // Podmínka nesmí být !value, protože chceme akceptovat číselnou hodnotu 0 a boolean hodnotu false
                if (value == null || value === '') {
                    (0, _set2.default)(errors, path, errorMessage);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return errors;
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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